import { RectangleStackIcon } from '@heroicons/react/24/solid';

const CompleteBadge = () => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      background: '#e3f2fd',
      color: '#1976d2',
      padding: '4px 10px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: '600',
      marginBottom: '6px',
    }}
  >
    <RectangleStackIcon className="w-4 h-4" />
    COMPLETE SEARCH
  </div>
);

export default CompleteBadge;
